import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('model-agent-verify-modal', require('@/dc-it/components/ModelAgentVerifyModal.vue').default)
Vue.component('manage-subscriptions-modal', require('@/dc-it/components/ManageSubscriptionsModal.vue').default)
